<template>
  <div class="page-content-wrapper"  v-check-permission="'edit-payments'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <template>
                <div class="invoice-title row">
                  <h4 class="mt-0 header-title col-md-8 mb-0">Nuevo pago</h4>
                </div>

                <hr>

                <div class="panel panel-default pb-0 mb-0">
                  <div class="p-2">

                    <h3 class="panel-title font-20"><strong>Datos del alumno</strong></h3>

                    <div class="row">
                      <div class="col-md-10">
                        <address>
                          <v-select id="user" :options="students" :value="payment.user" v-model="payment.user">
                            <span slot="no-options">No se han encontrado resultados.</span>
                          </v-select>
                          <small>Es posible filtrar por DNI, Apellido y Nombre, Carrera, etc.</small>
                        </address>
                      </div>
                    </div>

                    <h3 class="panel-title font-20"><strong>Datos del pago</strong></h3>

                    <div class="row mt-1">

                      <div class="col-md-4">
                        <address>
                          <strong>Tipo de pago</strong>
                          <p>
                            <select id="paymentTypes" class="custom-select form-control d-block w-75" v-model="payment.paymentType">
                              <option v-for="payType in paymentTypes" :value="payType.value">
                                {{ payType.text }}
                              </option>
                            </select>
                          </p>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Estado</strong>
                          <select id="paymentStatus" class="custom-select form-control d-block w-75" v-model="payment.paymentStatus">
                            <option v-for="state in paymentStatus" :value="state.value">
                              {{ state.text }}
                            </option>
                          </select>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Método de pago</strong>
                          <select id="paymentMethods" class="custom-select form-control d-block w-75" v-model="payment.paymentMethod">
                            <option v-for="method in paymentMethods" :value="method.value">
                              {{ method.text }}
                            </option>
                          </select>
                        </address>
                      </div>

                    </div>

                    <div class="row mt-1">

                      <div class="col-md-4">
                        <address>
                          <strong>Vencimiento</strong>
                          <masked-input mask="1111-11-11" type="text" class="form-control d-block w-75" v-model="payment.dueDate" />
                          <small>(El formato de la fecha es: YYYY-MM-DD. Por ejemplo 2020-04-09)</small>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Fecha de pago</strong>
                          <masked-input mask="1111-11-11" type="text" class="form-control d-block w-75" v-model="payment.paymentDate" />
                          <small>(El formato de la fecha es: YYYY-MM-DD. Por ejemplo 2020-04-09)</small><br>
                          <small>Completar solo si el pago fue realizado.</small>
                        </address>
                      </div>

                      <div class="col-md-4">
                        <address>
                          <strong>Número de recibo</strong>
                          <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0 w-75"  v-model="payment.receiptNumber" />
                          <small>Completar solo si el pago fue realizado.</small>
                        </address>
                      </div>

                    </div>

                    <div class="row">
                      <div class="col-md-8">

                        <h3 class="panel-title font-20"><strong>Periodo del pago</strong></h3>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4">
                              <label>Mes</label>
                              <select class="custom-select form-control" v-model="payment.month">
                                <option :value="null">Mes</option>
                                <option v-for="m in months" v-bind:value="m.value">
                                  {{ m.value }} ({{ m.text }})
                                </option>
                              </select>
                            </div>

                            <div class="col-md-4">
                              <label>Año</label>
                              <select class="custom-select form-control" v-model="payment.year">
                                <option :value="null">Año</option>
                                <option v-for="i in years" v-bind:value="i">
                                  {{ i }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <small>
                            Consideraciones a tener en cuenta:<br>
                            <ul>
                              <li>Debe seleccionar un mes y año en caso de que el tipo de pago sea una Cuota</li>
                              <li>Debe seleccionar el mes 1 (Enero) y el año en caso de que el tipo de pago sea Matrícula</li>
                              <li>Debe seleccionar el año en caso de que el tipo de pago sea Personalizado</li>
                            </ul>
                          </small>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="panel panel-default mt-0 pt-0 mb-0 pb-0">
                      <div class="p-2">
                        <h3 class="panel-title font-20"><strong>Otros detalles del pago</strong></h3>
                      </div>
                      <div class="">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                            <tr>
                              <td><strong>Item/Título</strong></td>
                              <td class="text-center"><strong>Descripción</strong></td>
                              <td class="text-center"><strong>Monto</strong></td>
                              <td class="text-center"><strong></strong></td>
                              <td class="text-right"><strong>Subtotal</strong></td>
                            </tr>
                            </thead>
                            <tbody>

                            <tr>
                              <td class="text-center">
                                <textarea v-model="payment.title" class="w-100 form-control" rows="1"></textarea>
                                <small>Es el nombre que vera el alumno en su listado.</small>
                              </td>
                              <td class="text-center">
                                <textarea v-model="payment.description" class="w-100 form-control" rows="1"></textarea>
                                <small>Es la descripción adicional que vera el alumno en su listado.</small>
                              </td>
                              <td class="text-center">
                                <div class="input-group bootstrap-touchspin">
                                  <span class="input-group-addon bootstrap-touchspin-prefix">$</span>
                                  <input id="amount" type="number" v-model="payment.amount" class="form-control" style="display: block; width: 100px;">
                                  <span class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span>
                                </div>
                              </td>
                              <td class="text-center"></td>
                              <td class="text-right">${{ payment.amount }}</td>
                            </tr>
                            <tr>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line text-center">
                                <strong>Total</strong></td>
                              <td class="thick-line text-right">${{ payment.amount }}</td>
                            </tr>

                            </tbody>
                          </table>
                        </div>

                        <div>
                          <div class="pull-right">
                            <router-link to="/list-payments" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                            <a class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import paymentStatus from '../data/paymentStatus'
  import paymentMethods from '../data/paymentMethods'
  import paymentTypes from '../data/paymentTypes'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-masked-input'
  import months from '../data/months'

  export default {
    name: 'add-payment',


    components: {
      vSelect,
      MaskedInput
    },


    created () {
      this.getStudentFileList();
    },


    data () {
      return {
        paymentStatus: paymentStatus,
        paymentMethods: paymentMethods,
        paymentTypes: paymentTypes,
        months: months,
        payment: {
          title: 'Plan de pago',
          paymentType: 'custom',
          amount: 0,
          amountPaid: 0,
          paymentStatus: 'pending',
          paymentMethod: 'mercadopago',
          receiptNumber: '',
          month: 0,
          year: (new Date().getFullYear()),
          user: null
        },
        error: false,
        students : [],
      }
    },

    computed: {

      studentFileList: function () {
        return this.$store.getters.getStudentFileList
      },

      years: function () {
        var minYear = 2018;
        var currentYear = (new Date()).getFullYear();
        var years = [];
        var i;

        for (i = minYear; i <= (currentYear + 1); i++) {
          years.push(i);
        }

        return years;
      }

    },

    watch: {
      'payment.paymentType': function (val) {
        if(val == 'fee') {
          this.payment.title = 'Cuota ' + this.payment.month + '/' + this.payment.year;
        } else if (val == 'enrollment') {
          this.payment.month = 1;
          this.payment.title = 'Matrícula ' + this.payment.year;
        } else if (val == 'custom') {
          this.payment.title = 'Plan de pago ' + this.payment.month + '/' + this.payment.year;
        }
      },
      'payment.month': function (val) {
        if(this.payment.paymentType == 'fee') {
          this.payment.title = 'Cuota ' + val + '/' + this.payment.year;
        } else if (this.payment.paymentType == 'enrollment') {
          this.payment.title = 'Matrícula ' + this.payment.year;
        } else if (this.payment.paymentType == 'custom') {
          this.payment.title = 'Plan de pago ' + val + '/' + this.payment.year;
        }
      },
      'payment.year': function (val) {
        if(this.payment.paymentType == 'fee') {
          this.payment.title = 'Cuota ' + this.payment.month + '/' + val;
        } else if (this.payment.paymentType == 'enrollment') {
          this.payment.title = 'Matrícula ' + val;
        } else if (this.payment.paymentType == 'custom') {
          this.payment.title = 'Plan de pago ' + this.payment.month + '/' + val;
        }
      }
    },


    methods: {


      getStudentFileList () {
        var self = this;
        this.$loader.loading();
        this.$store.dispatch('getStudentFileList')
          .then((response) => {

            response.data.forEach(function (item) {
              self.students.push({
                label: item.personalData.dni + ' - ' + item.personalData.lastName + ' ' + item.personalData.firstName + ' - (' + item.registration_to_career.level + 'º en ' + item.current_career + ' - Ciclo ' + item.registration_to_career.academicYear + ')',
                value: item.user
              })
            });

            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },


      submit: function () {
        const self = this;

        if(this.payment.amount.length == 0 || this.payment.amount == 0) {
          self.$message.error({text: 'Debes ingresar un monto mayor a cero.'});
          return false;
        }

        $('.save-btn').attr('disabled', true);

        this.$store.dispatch('editPayment', { payment: this.payment })
          .then((response) => {

            if(response.success) {
              self.$message.success();

              setTimeout(function () {
                self.$router.push('/list-payments')
              }, 500)

            } else {

              self.$message.error({text: response.message});

            }

            $('.save-btn').attr('disabled', false)
          })
          .catch((response) => {
            self.$message.error({text: response.message});
            $('.save-btn').attr('disabled', false)
          })
      }

    }
  }
</script>


<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .ex-page-content {
    margin-top: 40px;
  }
  address strong {
    padding-bottom: 5px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/screens/AddPaymentScreen.vue